<template>
  <video ref="videoPlayer" :autoplay="autoplay" class="video-js"></video>
</template>
  
<script>
import videojs from 'video.js';
import { SVG } from './utils/const';
import { handleUserKeyPress } from './utils/keyboard';
import { onCreate, onPlay, onTimeUpdate, onSeek, onPause, onLoad, Ended } from './utils/stats';
import { prepareData, service } from "./utils/services";
require('videojs-vr');
require('videojs-contrib-quality-levels');
require('videojs-hls-quality-selector');
require('videojs-vr/dist/videojs-vr.css');
export default {
  name: 'VideoPlayer',
  props: {
    autoplay: {
      type: Boolean,
      default() {
        return false;
      }
    },
    videoData: {
      type: Object
    },
    manifest: {
      type: Object
    },
    panorama: {
      type: Boolean,
      default() {
        return false;
      }
    },
    setPlayer: {
      type: Function
    },
    rightClick: {
      type: Function
    },
    leftClick: {
      type: Function
    },
    showSettingsModal: {
      type: Function
    },
    options: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      player: null,
      paused: false,
    }
  },
  methods: {
    handlePause() {
      // console.log("pausing player...", e);
      if(!this.player.paused())
        this.player.pause();
    }
  },
  mounted() {
    this.player = videojs(this.$refs.videoPlayer, this.options, () => {
      this.player.log('onPlayerReady', this);
    });
    onCreate(this.player);
    this.player.on('ready', async () => {
      this.player.stats_res = this.videoData.statsOptions;
      this.player.videoTitle = this.videoData.titleOptions;
      this.player.currentT = 0;
      this.player.HasSeeked = false;
      this.player.seekCount = 0;
      this.player.pauseCount = 0;
      this.player.manifest = this.manifest;
      // this.player.qualityLevels();
      /**
       * CREATE EVENT
       */
      let data = prepareData("create", this.player);
      await service(data);
      /**
       * STATS TRACKER
       * onPlay, onSeek, onPause, onLoad, Ended
       */
      onLoad(this.player);
      onPlay(this.player);
      onTimeUpdate(this.player);
      onSeek(this.player);
      onPause(this.player);
      Ended(this.player);

      /**
       * SET THE PLAYER FOR EXTERNAL REFERANCE
       */
      this.setPlayer(this.$refs.videoPlayer, this.player);

      /**
       * HANDLE 3D VIDEOS
       */
      if (this.panorama) {
        this.player.vr({
          projection: '360',
          motionControls: true
        });
      }
      this.player.playbackRates([0.25, 0.5, 0.75, 1, 1.25, 1.5, 2]);
      const levels = this.player.qualityLevels();
      this.player.hlsQualitySelector({
          displayCurrentQuality: true,
      });
      this.player.changeQuality = (i) => {
        levels.selectedIndex_ = i;
        levels.trigger({ type: 'change', selectedIndex: i });
      }

      /** SETTINGS BTN */
      let settingsButton = this.player.controlBar.addChild('button', {
        clickHandler: () => {
          this.showSettingsModal();
        }
      });
      this.player.controlBar
        .el()
        .insertBefore(settingsButton.el(), this.player.controlBar.getChild('fullscreenToggle').el());
      let settingsButtonDom = settingsButton.el();
      settingsButtonDom.innerHTML = SVG.SETTING_SVG;
      settingsButton.controlText('Paramétres (o)');
      /** END SETTINGS BTN */

      /**
       * KEYBOARD
       */
      window.addEventListener('keydown', (e) => {
        handleUserKeyPress(e, this.player);
      });
      /**
       * END KEYBOARD
       */
    });

    /**
     * Handle context menu
     */
    this.player.on('contextmenu', (e) => {
      this.rightClick(e);
    });
    this.player.on('click', (e) => {
      if(!this.player.paused() && this.player.currentTime() > 0 && !this.paused && !this.panorama) {
        this.player.pause();
        this.paused = true;
        this.leftClick(e);
      } else {
        this.paused = false;
        this.leftClick(e);
      }
    });

    /**
     * Handle left click
     */
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
}
</script>

<style>
html,
body,
.player__cdn {
  height: 100%;
  width: 100%;
  margin: 0px;
  padding: 0px;
  overflow: hidden;
}

.video-js {
  height: 100%;
  width: 100%;
}

.video-js {
  --vm-dropdown-bg: #e9e9e9;
  --vm-dropdown-btn-color: #999999;
  --vm-dropdown-btn-active-arrow-color: #5e5e5e;

  --vm-hr: #999999;
  --vm-video-preview-border: 2px solid #bdbdbd;
  --vm-video-preview-duration-bg: 94, 94, 94;
  --vm-video-preview-duration-color: #fff;

  --vm-card-bg: 242, 242, 242;
  --vm-border-color: #999999;

  --vm-modal-close-btn-bg: white;
  --vm-modal-background: #e9e9e9;
  --vm-modal-close-icon-color: #999999;
  --vm-modal-font-color: #5e5e5e;
  --vm-modal-section-btn-color: #313131;

  --vm-slider-thumb-bg: #000;

  --vm-slider-track-height: 8px;
  --vm-slider-track-focused-height: 10px;
  --vm-slider-track-color: rgba(255, 255, 255, 0.5);

  --vm-controls-bg-vars: 210, 210, 210;
  --vm-controls-border-radius: 0px;
  --vm-controls-border-radius: 0px;
  --vm-control-border-radius: 0px;
  --vm-control-icon-size: 26px;
  --vm-control-focus-color: black;

  --vm-scrubber-loading-stripe-size: 100px;
  --vm-scrubber-buffered-bg: rgba(0, 0, 0, 1);

  --vm-time-font-weight: 600;
  --vm-video-icons-border: 2px solid #999;
  --vm-video-input-font-color: #999;
  --vm-video-time-counter-font-color: #cfcfcf;
  --vm-video-textarea-resizer: #d2d2d2;
  --vm-shortcut-front-color: #d2d2d2;
  --vm-chapters-background-color: rgba(242, 242, 242, 0.52);
  --vm-chapters-scrollbar-color: #999999;
  --vm-chapters-scrollbar-background: #e9e9e9;

  --vm-current-chapters-background-color: #f2f2f2;
  --vm-color-picker-border-color: #999999;
  --vm-model-label-font-color: #787878;
  --vm-modal-stats-border: 1px solid #a9a9a9;
  --vm-spinner-fill-color: var(--vm-theme-color);
}

.vjs-quality-selector {
  display: none;
}

.video-js .vjs-control-bar {
  transition: transform 0.1s ease 0s !important;
  color: #fff;
  padding: 0.2em calc(2vw - .6em);
  height: 3em;
  z-index: 3;
  font-size: 14px !important;
  transition: 0.5s ease 0s !important;
  background: linear-gradient(0deg, black 0%, rgba(255, 255, 255, 0) 100%) !important;
}

.video-js .vjs-volume-bar {
  margin: 1.4em 0.3em !important;
}

.video-js .vjs-control {
  transform: translate(9%, 9%);
  margin-top: -5px !important;
}

.video-js .vjs-control svg {
  fill: white !important;
}

.video-js .vjs-control svg path {
  fill: #fff !important;
}

.vjs-slider-horizontal .vjs-volume-level {
  background-color: #E64444 !important;
}

.video-js .vjs-button-vr {
  display: none !important;
}

.video-js.vjs-playing .vjs-tech {
  pointer-events: none;
}

.video-js .vjs-volume-panel {
  transform: none !important;
  margin-top: 0.2px !important;
}

.video-js .vjs-fullscreen-control {
  transform: none !important;
}

.video-js .vjs-play-progress {
  background-color: var(--vm-theme-color) !important;
}

.video-js .vjs-progress-control {
  position: absolute !important;
  width: 100% !important;
  height: fit-content !important;
  transform: none !important;
}

.vjs-play-control .vjs-control .vjs-button .vjs-paused {
  margin-top: -5px !important;
}

.video-js .vjs-big-play-button {
  left: 50%;
  top: 50%;
  color: #fff;
  transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
  font-size: 3.5em;
  height: 2em !important;
  width: 2em !important;
  line-height: 1.7em !important;
  margin-top: -1em !important;
  margin-left: -1em;
  text-shadow: 2px 3px 5px rgba(0, 0, 0, 0.35);
  z-index: 2;
  transform: translate(25%, 5%) !important;
}

.video-js .vjs-load-progress {
  background-color: #fff !important;
}

.vjs-play-progress .vjs-slider-bar {
  z-index: 1;
}

.vjs-slider-horizontal .vjs-volume-level {
  background-color: var(--vm-theme-color) !important;
}

.video-js .vjs-progress-control .vjs-progress-holder {
  position: absolute;
  width: 100% !important;
  right: 0 !important;
  left: -0.5vw !important;
  height: 0.3em;
  top: -0.3em;
  max-width: calc(100% - 4vw);
  transition: 0.1s ease-in-out;
  height: 0.35em;
}

.vjs-big-play-button {
  top: 50%;
  left: 50%;
  border: none;
  color: #fff;
  transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
  background-color: transparent;
  font-size: 3.5em;
  border-radius: 0;
  height: 2em !important;
  width: 2em !important;
  line-height: 1.7em !important;
  margin-top: -1em !important;
  margin-left: -1em;
  text-shadow: 2px 3px 5px rgba(0, 0, 0, 0.35);
  z-index: 2;
}

.vjs-big-play-button:focus {
  background-color: rgba(0, 0, 0, 0);
}

.vjs-big-play-button:active {
  background-color: rgba(0, 0, 0, 0);
}

.vjs-big-play-button:before {
  font-size: 40px;
}

.vjs-paused .vjs-big-play-button {
  display: block;
}

.vjs-big-play-button {
  background-color: transparent !important;
  border: none !important;
}

.vjs-big-play-button {
  font-family: dark-skin !important;
  font-size: 50px !important;
  text-align: center;
}

.video-js.vjs-paused .vjs-big-play-button {
  display: block;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
}

.video-js.vjs-paused.vjs-user-active .vjs-progress-control .vjs-marker,
.video-js.vjs-paused.vjs-user-inactive .vjs-progress-control .vjs-marker {
  position: absolute;
  left: 0;
  bottom: 0em;
  opacity: 1;
  height: 100%;
  transition: opacity 0.2s ease;
  -webkit-transition: opacity 0.2s ease;
  -moz-transition: opacity 0.2s ease;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
}

.video-js.vjs-paused.vjs-user-active .vjs-progress-control .vjs-marker .type,
.video-js.vjs-paused.vjs-user-inactive .vjs-progress-control .vjs-marker .type {
  display: none;
}

.video-js .vjs-spacer {
  display: flex;
  flex: 1 1 auto;
}

.vjs-has-started .vjs-playing .vjs-control-bar {
  opacity: 1 !important;
  bottom: -42px !important;
}

.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {
  opacity: 1 !important;
  bottom: -42px !important;
}

.vjs-has-started .vjs-paused .vjs-control-bar {
  opacity: 1 !important;
  bottom: 0 !important;
}

.video-js .vjs-picture-in-picture-control {
  display: none;
}

.video-js .vjs-playback-rate {
  display: none;
}

.video-js .vjs-play-progress .vjs-time-tooltip {
  display: none !important;
}

.video-js .vjs-control-bar {
  transition: transform 0.1s ease 0s !important;
  color: #fff;
  padding: 0.2em calc(2vw - .6em);
  height: 3em;
  z-index: 3;
  font-size: 14px !important;
  transition: 0.5s ease 0s !important;
  background: linear-gradient(0deg, black 0%, rgba(255, 255, 255, 0) 100%) !important;
}

.video-js .vjs-volume-bar {
  margin: 1.4em 0.3em !important;
}

.video-js .vjs-control {
  transform: translate(9%, 9%);
  margin-top: -5px !important;
}

.video-js .vjs-control svg {
  fill: white !important;
}

.video-js .vjs-control svg path {
  fill: #fff !important;
}

.vjs-slider-horizontal .vjs-volume-level {
  background-color: #E64444 !important;
}

.video-js .vjs-button-vr {
  display: none !important;
}

.video-js.vjs-playing .vjs-tech {
  pointer-events: none;
}

.video-js .vjs-volume-panel {
  transform: none !important;
  margin-top: 0.2px !important;
}

.video-js .vjs-fullscreen-control {
  transform: none !important;
}

.video-js .vjs-play-progress {
  background-color: var(--vm-theme-color) !important;
}

.video-js .vjs-progress-control {
  position: absolute !important;
  width: 100% !important;
  height: fit-content !important;
  transform: none !important;
}

.vjs-play-control .vjs-control .vjs-button .vjs-paused {
  margin-top: -5px !important;
}

.video-js .vjs-big-play-button {
  left: 50%;
  top: 50%;
  color: #fff;
  transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
  font-size: 3.5em;
  height: 2em !important;
  width: 2em !important;
  line-height: 1.7em !important;
  margin-top: -1em !important;
  margin-left: -1em;
  text-shadow: 2px 3px 5px rgba(0, 0, 0, 0.35);
  z-index: 2;
  transform: translate(25%, 5%) !important;
}

.video-js .vjs-load-progress {
  background-color: #fff !important;
}

.vjs-play-progress .vjs-slider-bar {
  z-index: 1;
}

.vjs-slider-horizontal .vjs-volume-level {
  background-color: var(--vm-theme-color) !important;
}

.video-js .vjs-progress-control .vjs-progress-holder {
  position: absolute;
  width: 100% !important;
  right: 0 !important;
  left: -0.5vw !important;
  height: 0.3em;
  top: -0.3em;
  max-width: calc(100% - 4vw);
  transition: 0.1s ease-in-out;
  height: 0.35em;
}

.vjs-big-play-button {
  top: 50%;
  left: 50%;
  border: none;
  color: #fff;
  transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
  background-color: transparent;
  font-size: 3.5em;
  border-radius: 0;
  height: 2em !important;
  width: 2em !important;
  line-height: 1.7em !important;
  margin-top: -1em !important;
  margin-left: -1em;
  text-shadow: 2px 3px 5px rgba(0, 0, 0, 0.35);
  z-index: 2;
}

.vjs-big-play-button:focus {
  background-color: rgba(0, 0, 0, 0);
}

.vjs-big-play-button:active {
  background-color: rgba(0, 0, 0, 0);
}

.vjs-big-play-button:before {
  font-size: 40px;
}

.vjs-paused .vjs-big-play-button {
  display: block;
}

.vjs-big-play-button {
  background-color: transparent !important;
  border: none !important;
}

.vjs-big-play-button {
  font-family: dark-skin !important;
  font-size: 50px !important;
  text-align: center;
}

.video-js.vjs-paused .vjs-big-play-button {
  display: block;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
}

.video-js.vjs-paused.vjs-user-active .vjs-progress-control .vjs-marker,
.video-js.vjs-paused.vjs-user-inactive .vjs-progress-control .vjs-marker {
  position: absolute;
  left: 0;
  bottom: 0em;
  opacity: 1;
  height: 100%;
  transition: opacity 0.2s ease;
  -webkit-transition: opacity 0.2s ease;
  -moz-transition: opacity 0.2s ease;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
}

.video-js.vjs-paused.vjs-user-active .vjs-progress-control .vjs-marker .type,
.video-js.vjs-paused.vjs-user-inactive .vjs-progress-control .vjs-marker .type {
  display: none;
}

.video-js .vjs-spacer {
  display: flex;
  flex: 1 1 auto;
}

.vjs-has-started .vjs-playing .vjs-control-bar {
  opacity: 1 !important;
  bottom: -42px !important;
}

.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {
  opacity: 1 !important;
  bottom: -42px !important;
}

.vjs-has-started .vjs-paused .vjs-control-bar {
  opacity: 1 !important;
  bottom: 0 !important;
}

.video-js .vjs-picture-in-picture-control {
  display: none;
}

.video-js .vjs-playback-rate {
  display: none;
}

.video-js .vjs-play-progress .vjs-time-tooltip {
  display: none !important;
}
</style>
